// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__dhc0n","spinnerImage":"LoadingSpinner_spinnerImage__uzonW"};